const Animation = () => {
    return ( 
        <div class="animation">
            {/* <div className="slider"></div> */}
            <ul class="box-area">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
    );
}

export default Animation;